import type { SupportedTransferTypes } from '../components/Utility/VoPayApi/VoPayApi.types';

const transferFundOptions: { [key in SupportedTransferTypes]?: string } = {
  Transfer: 'Transfer',
  FundAndTransfer: 'Fund and Transfer',
  TransferAndWithdraw: 'Transfer and Withdraw',
  FundTransferAndWithdraw: 'Fund, Transfer and Withdraw',
};

export default transferFundOptions;
